import React from "react";
import { DataVariableContainer } from "../../container/panelReports";

const DownloadDataVariableScreen: React.FC<{}> = () => {
  return <DataVariableContainer/>;
}

export default DownloadDataVariableScreen;